import request from '@/utils/request'

// 查询访客登记列表
export function listVisits(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/visit.listVisits',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
